import Cookies from 'universal-cookie';
const cookies = new Cookies();

const clearCookies = () => {
  const allCookies = cookies.getAll();

  for (const cookie in allCookies) {
    cookies.remove(cookie);
  }
};

export default clearCookies;
